@if (!isMobile && hasTask('IdVerificationInstructions')) {
  <app-id-instructions
    [user]="user"
  ></app-id-instructions>
}
@if (hasTask('IdVerificationQrCode')) {
  <app-id-app-access
    [isMobile]="isMobile"
    [user]="user"
  ></app-id-app-access>
}
@if (hasTask('IdVerification')) {
  <app-id-verification-in-progress
    [isMobile]="isMobile"
    [user]="user"
  ></app-id-verification-in-progress>
}
